/* eslint-disable no-magic-numbers */

// One scale for every boxed form control — Input, SearchInput, and anything
// that has to line up next to them. The dropdown trigger keeps its own table
// because a chevron pays for different horizontal padding than text does.
//
// Pre-redesign names ('default' / 'small') stay as aliases so existing call
// sites keep compiling.
// ponytail: drop the aliases once no consumer passes them.
export const formInputSizes = {
	large: 'large',
	compact: 'compact',
	default: 'default',
	small: 'small',
} as const;

export type FormInputSize = typeof formInputSizes[keyof typeof formInputSizes];

export type FormInputSizeDefinition = {
	/** Fixed height of the box. */
	height: number;
	fontSize: number;
	/** Icon glyph size, for the controls that carry one. */
	iconSize: number;
	/** Gap between the pieces sharing the row. */
	gap: number;
	paddingHorizontal: number;
};

// Figma draws icons in 24 / 20 / 16 frames. The rebrand glyphs carry the frame's padding
// themselves (drawn on a 24 grid), so the font size is the frame as is.
// ponytail: kept as a ratio so the old icons' 17.8 / 24 is one edit away if the rebrand is rolled back.
const glyphRatio = 1;

const large: FormInputSizeDefinition = {
	height: 48,
	fontSize: 16,
	iconSize: 24 * glyphRatio,
	gap: 8,
	paddingHorizontal: 12,
};

const compact: FormInputSizeDefinition = {
	height: 36,
	fontSize: 14,
	iconSize: 20 * glyphRatio,
	gap: 8,
	paddingHorizontal: 6,
};

export const formInputSizeDefinitions: { [key in FormInputSize]: FormInputSizeDefinition } = {
	large,
	compact,
	default: large,
	small: compact,
};
